import type { SVGProps } from 'react'
const SvgSyCompassNorth = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M13.5 3a.5.5 0 0 0-.5.5v3.195l-1.979-3.297v-.002a.58.58 0 0 0-.619-.246.58.58 0 0 0-.402.53V8.5a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5V5.305l1.979 3.297v.002a.58.58 0 0 0 .619.246.58.58 0 0 0 .402-.53V3.5a.5.5 0 0 0-.5-.5"
		/>
		<path d="m6.2 20.634 5.668-10.393a.15.15 0 0 1 .264 0L17.8 20.634a.15.15 0 0 1-.187.211l-4.536-1.814a.15.15 0 0 1-.092-.113l-.837-4.606c-.03-.165-.266-.165-.296 0l-.837 4.606a.15.15 0 0 1-.092.113l-4.536 1.814a.15.15 0 0 1-.187-.21" />
	</svg>
)
export default SvgSyCompassNorth
